import Vue from 'vue'
import store from '@/store'

/**
 * Convert percent to decimal and cast to
 * a number to round off zeroes
 */
function formatUnitValue (value, type) {
  if (value === '<LOQ') {
    return value
  }

  if (type === 'percent') {
    value = (value * 100).toFixed(2)
  }

  return +value
}

/**
 * Append unit type to a given value
 */
function appendUnitType (value, type) {
  if (value === '<LOQ') {
    return value
  }

  let unit = '%'

  if (type !== 'percent') {
    unit = type
  }

  return `${formatUnitValue(value, type)}${unit}`
}

/**
 * Display helper for showing appropriate (function($){
 * thc or cbd units
 */
Vue.filter('cbd-thc-units', function (value, type) {
  return appendUnitType(value, type)
})

/**
 * Display helper for showing a differing range of
 * thc or cbd for a given product
 */
Vue.filter('cbd-thc-display', function (obj) {
  const { low, high, unit_type: unit } = obj
  let lowTranslate = low

  if ((low === 0.0 || low === '0.0' || low === '0') && store.getters['venue/useLOQ']) {
    lowTranslate = '<LOQ'
  }

  if (low === high) {
    return appendUnitType(lowTranslate, unit)
  }

  return `${formatUnitValue(lowTranslate, unit)}-${appendUnitType(high, unit)}`
})
